module.exports = __webpack_public_path__ + "images/pie-chart-icon.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/pie-chart-icon.png
// module id = 203
// module chunks = 0